import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './FlipCards.css';
import { IoSettingsOutline } from "react-icons/io5";
import { SlPeople } from "react-icons/sl";
import { TbInfoOctagon } from "react-icons/tb";
import { SiCrystal } from "react-icons/si";
import { FaServer, FaEnvelope, FaCloud } from "react-icons/fa";
import { Link } from 'react-router-dom';

const FlipCards = () => {
  const cards = [
    {
      title: "Networking",
      frontIcon: <SlPeople />,
      backTitle: "Networking Services",
      backText: "Campus-wide network infrastructure and services for seamless connectivity.",
      link: "/services-network",
      email: "netadm@cc.iitd.ac.in"
    },
    {
      title: "Software",
      frontIcon: <IoSettingsOutline />,
      backTitle: "Software Solutions",
      backText: "Licensed software and development solutions for academic excellence.",
      link: "/services-software",
      email: "scisoft@cc.iitd.ac.in"
    },
    {
      title: "Web Services",
      frontIcon: <TbInfoOctagon />,
      backTitle: "Web Services",
      backText: "Hosting and web application development services for the institute.",
      link: "/services-web-services",
      email: "webgroup@cc.iitd.ac.in"
    },
    {
      title: "ERP",
      frontIcon: <SiCrystal />,
      backTitle: "ERP Services",
      backText: "Enterprise Resource Planning solutions for institutional management.",
      link: "/services-erp",
      email: "eadminhelp@iitd.ac.in"
    },
    {
      title: "HPC",
      frontIcon: <FaServer />,
      backTitle: "High Performance Computing",
      backText: "Advanced computing resources for research and complex computations.",
      link: "https://supercomputing.iitd.ac.in/",
      email: "hpchelp@iitd.ac.in"
    },
   {
  title: "Baadal",
  frontIcon: <FaCloud />,
  backTitle: "Baadal Cloud Services",
  backText: "Baadal is a management and orchestration software for the IITD private cloud for high performance computing.",
  link: "https://baadal.iitd.ac.in/baadal",
  email: "baadalsupport@cc.iitd.ac.in"
}
  ];

  // Helper function to get all emails as array
  const getAllEmails = (emailString) => {
    if (!emailString) return [];
    return emailString.split(',').map(email => email.trim()).filter(email => email !== '');
  };

  return (
    <div className="container py-4">
      <div className="row g-4">
        <div className='d-flex justify-content-center'>
          <h1 className="alumni-title text-uppercase mt-4 mb-4">
            <span style={{color:"#686464"}}>Quick </span>Links
          </h1>
        </div>
        {cards.map((card, index) => (
          <div key={index} className="col-md-4">
            <Link to={card.link} className="text-decoration-none">
              <div className="flip-card">
                <div className="flip-card-inner">
                  {/* Front Side - Only First Email */}
                  <div className="flip-card-front">
                    <div className="card h-100 border-0">
                      <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
                        <div className={`card-icon ${card.frontIcon.type === IoSettingsOutline ? 'rotate-icon' : ''}`}>
                          {card.frontIcon}
                        </div>
                        <h3 className="card-title mt-3">{card.title}</h3>
                        
                        {/* All Emails on Front */}
                        <div className="email-section-front mt-3">
                          {getAllEmails(card.email).map((email, idx) => (
                            <div key={idx} className="email-front d-flex align-items-center justify-content-center gap-2" style={{marginBottom: '6px'}}>
                              <FaEnvelope size={12} />
                              <small className="email-text-front">
                                {email}
                              </small>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Back Side - All Emails */}
                  <div className="flip-card-back">
                    <div className="card h-100 border-0">
                      <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
                        <h3 className="card-title servicestitle mb-3">{card.backTitle}</h3>
                        <p className="card-text servicesdesc m-0">
                          {card.backText}
                        </p>
                        
                        {/* All Emails on Back */}
                        <div className="email-section-back mt-3">
                          <hr style={{opacity:"1"}}/>
                          <small>Email:</small>
                          <div className="email-back">
                            {getAllEmails(card.email).map((email, idx) => (
                              <div key={idx} className="email-item d-flex align-items-center justify-content-center gap-2">
                                <FaEnvelope size={10} />
                                <span>{email}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlipCards;


// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './FlipCards.css';
// import { IoSettingsOutline } from "react-icons/io5";
// import { SlPeople } from "react-icons/sl";
// import { TbInfoOctagon } from "react-icons/tb";
// import { SiCrystal } from "react-icons/si";
// import { FaServer, FaEnvelope, FaCloud } from "react-icons/fa";
// import { Link } from 'react-router-dom';
// import QuickContacts from './QuickContacts.jsx'; // Import the new component

// const FlipCards = () => {
//   const cards = [
//     {
//       title: "Networking",
//       frontIcon: <SlPeople />,
//       backTitle: "Networking Services",
//       backText: "Campus-wide network infrastructure and services for seamless connectivity.",
//       link: "/services-network",
//       email: "netadm@cc.iitd.ac.in"
//     },
//     {
//       title: "Software",
//       frontIcon: <IoSettingsOutline />,
//       backTitle: "Software Solutions",
//       backText: "Licensed software and development solutions for academic excellence.",
//       link: "/services-software",
//       email: "scisoft@cc.iitd.ac.in"
//     },
//     {
//       title: "Web Services",
//       frontIcon: <TbInfoOctagon />,
//       backTitle: "Web Services",
//       backText: "Hosting and web application development services for the institute.",
//       link: "/services-web-services",
//       email: "webgroup@cc.iitd.ac.in"
//     },
//     {
//       title: "ERP",
//       frontIcon: <SiCrystal />,
//       backTitle: "ERP Services",
//       backText: "Enterprise Resource Planning solutions for institutional management.",
//       link: "/services-erp",
//       email: "eadminhelp@iitd.ac.in"
//     },
//     {
//       title: "HPC",
//       frontIcon: <FaServer />,
//       backTitle: "High Performance Computing",
//       backText: "Advanced computing resources for research and complex computations.",
//       link: "https://supercomputing.iitd.ac.in/",
//       email: "hpchelp@iitd.ac.in"
//     },
//     {
//       title: "Baadal",
//       frontIcon: <FaCloud />,
//       backTitle: "Baadal Cloud Services",
//       backText: "Baadal is a management and orchestration software for the IITD private cloud for high performance computing.",
//       link: "https://baadal.iitd.ac.in/baadal",
//       email: "baadalsupport@cc.iitd.ac.in"
//     }
//   ];

//   // Helper function to get all emails as array
//   const getAllEmails = (emailString) => {
//     if (!emailString) return [];
//     return emailString.split(',').map(email => email.trim()).filter(email => email !== '');
//   };

//   return (
//     <div className="container py-4">
//       <div className="row g-4">
//         <div className='d-flex justify-content-center'>
//           <h1 className="alumni-title text-uppercase mt-4 mb-4">
//             <span style={{color:"#686464"}}>Quick </span>Links
//           </h1>
//         </div>
        
//         <div className="col-lg-8">
//           <div className="row g-4">
//             {cards.map((card, index) => (
//               <div key={index} className="col-md-6 col-lg-4">
//                 <Link to={card.link} className="text-decoration-none">
//                   <div className="flip-card">
//                     <div className="flip-card-inner">
//                       {/* Front Side - Only First Email */}
//                       <div className="flip-card-front">
//                         <div className="card h-100 border-0">
//                           <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
//                             <div className={`card-icon ${card.frontIcon.type === IoSettingsOutline ? 'rotate-icon' : ''}`}>
//                               {card.frontIcon}
//                             </div>
//                             <h3 className="card-title mt-3">{card.title}</h3>
                            
//                             {/* All Emails on Front */}
//                             <div className="email-section-front mt-3">
//                               {getAllEmails(card.email).map((email, idx) => (
//                                 <div key={idx} className="email-front d-flex align-items-center justify-content-center gap-2" style={{marginBottom: '6px'}}>
//                                   <FaEnvelope size={12} />
//                                   <small className="email-text-front">
//                                     {email}
//                                   </small>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
                      
//                       {/* Back Side - All Emails */}
//                       <div className="flip-card-back">
//                         <div className="card h-100 border-0">
//                           <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
//                             <h3 className="card-title servicestitle mb-3">{card.backTitle}</h3>
//                             <p className="card-text servicesdesc m-0">
//                               {card.backText}
//                             </p>
                            
//                             {/* All Emails on Back */}
//                             <div className="email-section-back mt-1">
//                               <hr style={{opacity:"1",margin:"10px"}}/>
//                               <small>Email:</small>
//                               <div className="email-back">
//                                 {getAllEmails(card.email).map((email, idx) => (
//                                   <div key={idx} className="email-item d-flex align-items-center justify-content-center gap-2">
//                                     <FaEnvelope size={10} />
//                                     <span>{email}</span>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Quick Contacts Sidebar */}
//         <div className="col-lg-4">
//           <QuickContacts />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FlipCards;